import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { SpacesViewModel } from 'models';

import { SharedUiSpaceDetailsWrapper } from '../offers/space-details-wrapper';
import { SpacesWrapper } from 'components/infosite/property-space-details';

export const SharedUiSpaceDetailsExperiment: React.FC<{ spacesViewModel: SpacesViewModel }> = ({ spacesViewModel }) => (
  <Experiment name="PDPSharedUIGroup2">
    <ExperimentControl>
      <SpacesWrapper spacesViewModel={spacesViewModel} singleColumn={true} />
    </ExperimentControl>
    <ExperimentVariant bucket={1}>
      <SharedUiSpaceDetailsWrapper />
    </ExperimentVariant>
  </Experiment>
);
